import update from 'immutability-helper';
import VisualStaticLoadingModalEnum from './VisualStaticLoadingModalConstants';

const initialState = {
  isVisualStaticLoadingModalOpen: false,
  visualStaticLoadingModalExportUrl: '',
};

const VisualStaticLoadingModalReducer = (state, action) => {
  if (typeof state === 'undefined') {
    return initialState;
  }

  switch (action.type) {
    case VisualStaticLoadingModalEnum.VISUAL_STATIC_LOADING_MODAL_OPEN:
      return update(state, {
        isVisualStaticLoadingModalOpen: { $set: true },
      });
    case VisualStaticLoadingModalEnum.VISUAL_STATIC_LOADING_MODAL_EXPORT_URL_SET:
      return update(state, {
        visualStaticLoadingModalExportUrl: { $set: action.visualStaticLoadingModalExportUrl },
      });
    default:
      return state;
  }
};

export default VisualStaticLoadingModalReducer;



// WEBPACK FOOTER //
// ./src-react/Modals/VisualStaticLoadingModal/VisualStaticLoadingModalReducer.jsx